import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";
import axios from "axios";
import { ApplicationForm } from "./ApplicationForm";
import { RemitaStore } from "./remitaStore";

Vue.use(Vuex);
const vuexLocalStorage = new VuexPersist({
  key: "vuex",
  storage: window.localStorage,
  reducer: (state) => {
    const { globalSpinnerVisible, ...rest } = state;
    return rest;
  },
});

export default new Vuex.Store({
  state: {
    User: {
      id: "",
      type: "",
      token: "",
      fullname: "",
      email: "",
      isVerified: false,
    },
    student: {},
    programmes: "",
    programmeTypesForApplication: "",
    applicationPayment: "",
    applicationLists: "",
    profileImage: null,
    studentBillPerProg: {
      cumplusoryFee: [],
      optionalFee: [],
    },
    globalSpinnerVisible: false,
  },
  mutations: {
    setStudentBillPerProg(state, billPerProg) {
      state.studentBillPerProg.cumplusoryFee = billPerProg.cumplusoryFee;
      state.studentBillPerProg.optionalFee = billPerProg.optionalFee;
    },
    setUser(state, paylaod) {
      if (paylaod == "signout") {
        state.User.id = "";
        state.User.fullname = "";
        state.User.type = "";
        state.User.email = "";
        state.User.mobile = "";
        state.User.isVerified = false;
      } else {
        state.User.id = paylaod.id;
        state.User.fullname =
          paylaod.surname + " " + paylaod.firstname + " " + paylaod.lastname;
        state.User.type = paylaod.type;
        state.User.email = paylaod.email;
        state.User.mobile = paylaod.mobile;
        state.User.isVerified = paylaod.email_verified_at ? true : false;
      }
    },
    setToken(state, token) {
      if (token == "sigout") {
        state.User.token = "";
      } else {
        state.User.token = token;
      }
    },
    clearAllUserData(state) {
      // Clear all user-related state
      state.User = {
        id: "",
        type: "",
        token: "",
        fullname: "",
        email: "",
        mobile: "",
        isVerified: false,
      };
      state.student = {};
      state.programmes = "";
      state.programmeTypesForApplication = "";
      state.applicationPayment = "";
      state.applicationLists = "";
      state.profileImage = null;
      state.studentBillPerProg = {
        cumplusoryFee: [],
        optionalFee: [],
      };
      state.globalSpinnerVisible = false;
    },
    setIsVerified(state, isVerified) {
      state.User.isVerified = isVerified;
    },
    setApplicationPayment(state, payment) {
      state.applicationPayment = payment;
    },
    setApplicationLists(state, applicationLists) {
      state.applicationLists = applicationLists;
    },
    setApplicationForm(state, formData) {
      state.applicationForm.personalDetails = formData.personaldetails;
      state.applicationForm.assestmentForm = formData.assessment;
      state.applicationForm.reference = formData.refree;
      state.applicationForm.employmentHistory = formData.employmenthistory;
      state.applicationForm.credentials = formData.credentials;
      state.applicationForm.institutionDetails = formData.institution;
    },
    setUpdateSingleApplication(state, application) {
      // console.log("commit here");
      // console.log(application);
      const index = application.index;
      delete application.index;
      state.applicationLists[index] = application;
    },
    setProgrammes(state, programmes) {
      state.programmes = programmes;
    },
    setProgrammeTypesForApplication(state, programmeTypes) {
      state.programmeTypesForApplication = programmeTypes;
    },
    setProfileImage(state, profileImage) {
      state.profileImage = profileImage;
    },
    setStudent(state, payload) {
      state.student = payload;
    },
    setGlobalSpinnerVisible(state, isVisible) {
      state.globalSpinnerVisible = isVisible;
    },
    toggleGlobalSpinner(state) {
      state.globalSpinnerVisible = !state.globalSpinnerVisible;
    },
  },
  actions: {
    getUser(context, User) {
      context.commit("setUser", User);
    },
    getProfileImage(context, profileImage) {
      context.commit("setProfileImage", profileImage);
    },
    checkAuth(context) {
      return new Promise((res, rej) => {
        if (context.state.User.token && context.state.User.token !== "signout") {
          res(true);
        } else {
          rej(false);
        }
      });
    },
    Login(context, cred) {
      return new Promise((res, rej) => {
        axios
          .post("/pgLogin", cred)
          .then((response) => {
            if (response.data.msg == "success") {
              context.commit("setUser", response.data.user);
              context.commit("setToken", response.data.token);
              res(response.data.user);
            } else {
              rej(response.data);
            }
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    studentLogin(context, cred) {
      return new Promise((res, rej) => {
        axios
          .post("/pgStudentLogin", cred)
          .then((response) => {
            if (response.data.msg == "success") {
              context.commit("setUser", response.data.user);
              context.commit("setToken", response.data.token);
              context.commit("setStudent", response.data.student);
              res(response.data.user);
            } else {
              rej(response.data);
            }
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    signOut(context) {
      return new Promise((res, rej) => {
        axios
          .post("pgSignOut")
          .then((response) => {
            if (response.data.msg == "success") {
              context.commit("clearAllUserData");
              window.localStorage.removeItem("vuex");
              res();
            } else {
              context.commit("clearAllUserData");
              window.localStorage.removeItem("vuex");
              res();
            }
          })
          .catch((err) => {
            context.commit("clearAllUserData");
            window.localStorage.removeItem("vuex");
            rej(err);
          });
      });
    },
    manualSignOut(context) {
      return new Promise((res, rej) => {
        try {
          context.commit("clearAllUserData");
          window.localStorage.removeItem("vuex");
          res();
        } catch (error) {
          rej();
        }
      });
    },
    verifyMail(context, data) {
      return new Promise((res, rej) => {
        axios
          .post("pgVerifyEmail", { id: data.user.id, token: data.otp })
          .then((response) => {
            if (response.data.msg == "success") {
              context.commit("setIsVerified", true);
              res(response.data.value);
            } else {
              context.commit("setGlobalSpinnerVisible", false);
              rej(response.data);
            }
          })
          .catch((err) => {
            context.commit("setGlobalSpinnerVisible", false);
            rej(err);
          });
      });
    },
    resendVerifyMail(context, user) {
      return new Promise((res, rej) => {
        axios
          .post("pgResendVerificationMail", user)
          .then((response) => {
            if (response.data.msg == "success") {
              res(response.data.value);
            } else {
              context.commit("setGlobalSpinnerVisible", false);
              rej(response.data);
            }
          })
          .catch((err) => {
            context.commit("setGlobalSpinnerVisible", false);
            rej(err);
          });
      });
    },
    getApplicationPayment(context, programme_type) {
      return new Promise((res, rej) => {
        axios
          .get("applicationFee", {
            params: { programme_type: programme_type },
          })
          .then((response) => {
            if (response.data.msg == "success") {
              context.commit("setApplicationPayment", response.data.payment);
              res(response.data.payment);
            } else {
              rej(response.data);
            }
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    paymentApplicationSuccess(context, data) {
      return new Promise((res, rej) => {
        axios
          .post("paymentApplicationSuccess", data)
          .then((response) => {
            if (response.data.msg == "success") {
              res(true);
            } else {
              rej(response.data);
            }
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    applicationLists(context) {
      return new Promise((res, rej) => {
        axios
          .get("pgApplicationLists")
          .then((response) => {
            if (response.data.msg == "success") {
              context.commit("setApplicationLists", response.data.value);
              res(response.data.value);
            } else {
              rej(response.data);
            }
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    updateSingleApplication(context, application) {
      context.commit("setUpdateSingleApplication", application);
    },
    applicationForm(context, application) {
      return new Promise((res, rej) => {
        try {
          // context.commit('setApplicationForm', application)
          context.commit("ApplicationForm/setApplicationForm", application);
          res(true);
        } catch (err) {
          console.log(err + "applicationForm error");
          rej(false);
        }
      });
    },
    getProgrammes(context) {
      return new Promise((res, rej) => {
        axios
          .get("getProgrammes")
          .then((response) => {
            context.commit("setProgrammes", response.data.programmes);
            res(response.data.programmes);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    getProgrammeTypesForApplication2(context) {
      axios
        .get("getProgrammeTypesForApplication")
        .then((response) => {
          context.commit(
            "setProgrammeTypesForApplication",
            response.data.types
          );
        })
        .catch(() => {});
    },
    //remita or payment functions
    initTransaction(context, { payment, gateway }) {
      return new Promise((res, rej) => {
        axios
          .post("initTransaction", { payment: payment, gateway: gateway || "interswitch" })
          .then((response) => {
            context.dispatch("hideGlobalSpinner");
            if (response.data.msg == "success") {
              res(response);
            } else {
              rej(response.data);
            }
          })
          .catch((err) => {
            context.dispatch("hideGlobalSpinner");
            rej(err);
          });
      });
    },
    interswitchPayment(context, config) {
      return new Promise((res, rej) => {
        try {
          const user = context.state.User;
          var paymentRequest = {
            merchant_code: config.merchant_code,
            pay_item_id: config.pay_item_id,
            pay_item_name: config.payment_type || "Payment",
            txn_ref: config.txn_ref,
            amount: config.amount,
            currency: 566,
            cust_name: user.fullname || "",
            cust_email: user.email || "",
            cust_id: String(user.id || ""),
            cust_mobile_no: user.mobile || "",
            site_redirect_url: window.location.origin,
            onComplete: function (response) {
              axios
                .post("interswitch/verify", {
                  txn_ref: config.txn_ref,
                  payment_type: config.payment_type,
                  programme_type: config.programme_type,
                })
                .then((verifyRes) => {
                  res(verifyRes);
                })
                .catch((err) => {
                  rej(err);
                });
            },
            mode: "LIVE",
          };
          window.webpayCheckout(paymentRequest);
        } catch (error) {
          Toast.fire({
            icon: "error",
            title: "Connection to Interswitch failed",
          });
          rej(error);
        }
      });
    },
    studentBillPerProg(context, billingPerProg) {
      context.commit("setStudentBillPerProg", billingPerProg);
    },
    showGlobalSpinner(context) {
      context.commit("setGlobalSpinnerVisible", true);
    },
    hideGlobalSpinner(context) {
      context.commit("setGlobalSpinnerVisible", false);
    },
    toggleGlobalSpinnerAction(context) {
      context.commit("toggleGlobalSpinner");
    },
  },
  modules: {
    ApplicationForm,
    RemitaStore,
  },
  getters: {
    isAuthenticatedApplicant: (state) => {
      if (
        state.User.type == "applicant" &&
        state.User.token != "signout" &&
        state.User.token
      ) {
        return true;
      } else {
        return false;
      }
    },
    isAuthenticatedStudent: (state) => {
      if (
        state.User.type == "student" &&
        state.User.token &&
        state.User.token != "signout"
      ) {
        return true;
      } else {
        return false;
      }
    },
    isAuthenticated: (state) => {
      if (state.User.token && state.User.token != "signout") {
        return { type: state.User.type, state: true };
      } else {
        return { state: false };
      }
    },
    isGlobalSpinnerVisible: (state) => {
      return state.globalSpinnerVisible;
    },
  },
  // student update
  plugins: [vuexLocalStorage.plugin],
});
